import { initMap } from 'allink-core-static/js/modules/map';

$(function(){

    var options = {
        pin_width: 52,
        pin_height: 90,
    };

    initMap(options);

});



// WEBPACK FOOTER //
// ./static/js/modules/map.js